import LegalText from './LegalText';

export default LegalText;
